import * as Types from '@praceprofirmy/shared-domain';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateCalendarEventParticipantMutationVariables = Types.Exact<{
  createCalendarEventParticipantInput: Types.CreateCalendarEventParticipantInput;
}>;


export type CreateCalendarEventParticipantMutation = { __typename?: 'Mutation', createCalendarEventParticipant: { __typename?: 'CalendarEventParticipant', id: string, participantId: string } };

export type RemoveCalendarEventParticipantMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type RemoveCalendarEventParticipantMutation = { __typename?: 'Mutation', removeCalendarEventParticipant: { __typename?: 'CalendarEventParticipant', id: string, participantId: string } };

export const CreateCalendarEventParticipantDocument = gql`
    mutation CreateCalendarEventParticipant($createCalendarEventParticipantInput: CreateCalendarEventParticipantInput!) {
  createCalendarEventParticipant(
    createCalendarEventParticipantInput: $createCalendarEventParticipantInput
  ) {
    id
    participantId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCalendarEventParticipantGQL extends Apollo.Mutation<CreateCalendarEventParticipantMutation, CreateCalendarEventParticipantMutationVariables> {
    document = CreateCalendarEventParticipantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCalendarEventParticipantDocument = gql`
    mutation RemoveCalendarEventParticipant($id: String!) {
  removeCalendarEventParticipant(id: $id) {
    id
    participantId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCalendarEventParticipantGQL extends Apollo.Mutation<RemoveCalendarEventParticipantMutation, RemoveCalendarEventParticipantMutationVariables> {
    document = RemoveCalendarEventParticipantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }